import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  //@ts-ignore ts being weird, this package exists
} from '@repo/ui/UnstyledAccordion';
import clsx from 'clsx';

import type { ProcessedSMS } from './Message';

import type { Mercury } from '@repo/types/Models';
import { Link } from 'react-router';

interface SegmentsDropdownProps {
  direction: Mercury.Models.SMS['direction'];
  accountId: Mercury.Models.Account['id'];
  node: ProcessedSMS;
}

const SegmentsDropdown = ({ accountId, direction, node }: SegmentsDropdownProps) => {
  return (
    <div
      className={clsx(
        ' flex w-full',
        direction === 'INBOUND' ? 'ml-auto  justify-end' : 'mr-auto  justify-start'
      )}
    >
      <Accordion type="single" collapsible className="p-2 rounded-lg bg-grey-300 dark:bg-blue-1000">
        <AccordionItem value={node.id}>
          <AccordionTrigger
            className={clsx(
              `flex  py-0 w-sm  `,
              node.direction === 'INBOUND' ? 'justify-end' : 'justify-start'
            )}
          >
            <span className="w-full">Segment count: {node.nodes.length}</span>
          </AccordionTrigger>
          <AccordionContent
            className={clsx(
              'flex mt-2 pb-0',
              node.direction === 'INBOUND' ? 'justify-end' : 'justify-start'
            )}
          >
            <div className="flex flex-col items-end text-sm">
              {node.nodes.map((childNode) => (
                <div key={childNode.id} className="flex items-center gap-1 ">
                  <Link
                    to={`/a/${accountId}/messaging/smses/${childNode.id}`}
                    className="flex items-center gap-1 transition-colors text-grey-700 hover:text-grey-1000 dark:text-blue-300 dark:hover:text-blue-100"
                  >
                    <span className="!text-lg/0 material-symbols-outlined">link</span>
                    {childNode.id}
                    <span className="ml-2">{childNode.status}</span>
                  </Link>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default SegmentsDropdown;
